import axios from "./axios"

function search(search) {
    return axios().get("/ledger-accounts-search", {
        params: {
            search,
            relations: ["currency"]
        }
    })
}
export default {
    search
}